import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insidePages } from '../data/insidePages';
import { OFFER_ANCHOR } from '../data/constants';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const [active, setActive] = useState(0);
  const scrollTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(index, insidePages.length - 1));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setActive(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const next = Math.round(track.scrollLeft / track.clientWidth);
      setActive(Math.max(0, Math.min(next, insidePages.length - 1)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const arrowClass = 'absolute top-1/2 z-10 -translate-y-1/2 rounded-full border-2 border-white bg-electric p-2 text-white shadow-lg transition-[background-color,opacity] duration-150 ease-out hover:bg-electrichover disabled:pointer-events-none disabled:opacity-0 sm:p-3';
  return <section className="bg-navy py-5 sm:py-8" data-id="element-83" data-mp="f2snancb58a9">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-84" data-mp="ezy2gupdtlgb">
        <h2 className="text-center text-3xl leading-none text-white sm:text-5xl" data-id="element-85" data-mp="3nim2myuwkdpq">
          Look <span className="text-electric" data-id="element-86" data-mp="3ij97zrxsi2cl">inside</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-87" data-mp="11zr7y6cy551">
          Discover What's Inside HOME APPLIANCE DIAGNOSTIC PRO™
        </p>
        <p className="mx-auto mt-1.5 max-w-3xl text-center text-sm leading-snug text-steel sm:text-base" data-id="element-88" data-mp="34r31kxkfv9qc">
          Electrical testing, wiring diagrams, component diagnostics, refrigerators,
          freezers, washing machines, dryers, dishwashers, ovens, ranges, heating
          faults, cooling faults, drain problems, component testing, symptom-based
          troubleshooting and structured fault isolation.
        </p>

        <div className="relative mt-3" data-id="element-89" data-mp="1de50pnbeio17">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto overscroll-x-contain" aria-label="Interior pages carousel" data-id="element-90" data-mp="1dfgcoaf0323e">
            {insidePages.map((page, i) => <div key={page.src} className="w-full shrink-0 snap-center px-1" role="group" aria-roledescription="slide" aria-label={`Page ${i + 1} of ${insidePages.length}`} data-id="element-91" data-mp="pokbwnskgwk0" data-mpi={i}>
                <a href={OFFER_ANCHOR} className="mx-auto block max-w-xl overflow-hidden rounded-lg border-4 border-white bg-white shadow-2xl" data-id="element-92" data-mp="yne7qby2piwi">
                  <img src={page.src} alt={page.alt} loading={i === 0 ? 'eager' : 'lazy'} className="block w-full object-contain" data-id="element-93" data-mp="2a6qps6wf7ce5" />
                </a>
              </div>)}
          </div>

          <button type="button" onClick={() => scrollTo(active - 1)} disabled={active === 0} aria-label="Previous page" className={`${arrowClass} left-1 sm:left-6`} data-id="element-94" data-mp="2agolylo38nci">
            <ChevronLeftIcon className="h-5 w-5" strokeWidth={3} data-id="element-95" data-mp="1wj0ag4fwusk4" />
          </button>
          <button type="button" onClick={() => scrollTo(active + 1)} disabled={active === insidePages.length - 1} aria-label="Next page" className={`${arrowClass} right-1 sm:right-6`} data-id="element-96" data-mp="1rjx8isv892gd">
            <ChevronRightIcon className="h-5 w-5" strokeWidth={3} data-id="element-97" data-mp="3lxeu4ac2np8r" />
          </button>
        </div>

        <div className="mt-2.5 flex items-center justify-center gap-2" data-id="element-98" data-mp="3hxe9g7ydqht9">
          {insidePages.map((page, i) => <button key={page.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === active} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-out ${i === active ? 'w-7 bg-electric' : 'w-2 bg-navyline hover:bg-steel'}`} data-id="element-99" data-mp="3oxzykw3b3qfh" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}